import component from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-form/lni-retaliation-form.component.vue';
import module from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-form/lni-retaliation-form.module.js';

export default {
    component,
    module,
};